export enum ObjectClass {
  Mezz = "Mezz",
  Raw = "Raw",
  MezzAuto = "MezzAuto",
  Dcp = "Dcp",
  Imf = "Imf",
  DolbyAtmos = "DolbyAtmos",
  Dash = "Dash",
  Generated = "Generated",
  Imported = "Imported",
  BundlePackage = "BundlePackage",
  BundleComponent = "BundleComponent",
  Group = "Group",
  Project = "Project",
  Drive = "Drive",
}
